(function () {
  var DESKTOP_BREAKPOINT = 990;

  function initFeaturedProductsSlider(section) {
    var containers;
    if (section) {
      containers = section.querySelectorAll('[data-featured-products-slider]');
    } else {
      containers = document.querySelectorAll('[data-featured-products-slider]');
    }

    if (!containers.length) return;
    if (typeof Swiper === 'undefined') return;

    containers.forEach(function (container) {
      var enableSlider = container.dataset.enableSlider === 'true';
      var enableSwipeMobile = container.dataset.enableSwipeMobile === 'true';
      var isMobile = window.innerWidth < DESKTOP_BREAKPOINT;

      // Destroy if slider disabled, or if on mobile without swipe enabled
      if (!enableSlider || (isMobile && !enableSwipeMobile)) {
        if (container.swiper) {
          container.swiper.destroy(true, true);
        }
        // Remove swiper-initialized class so CSS falls back to grid
        container.classList.remove('swiper-initialized');
        return;
      }

      var slidesCount = container.querySelectorAll('.swiper-slide').length;
      var productsToShow = parseInt(container.dataset.productsToShow, 10) || 4;

      // Don't init if not enough slides
      if (slidesCount <= 1) return;

      // Destroy previous instance before reinitializing
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }

      // Mobile Swiper config
      if (isMobile && enableSwipeMobile) {
        var slidesPerView = parseFloat(container.dataset.slidesPerView) || 2;
        var centeredSlides = container.dataset.centeredSlides === 'true';

        new Swiper(container, {
          slidesPerView: slidesPerView,
          spaceBetween: 0,
          centeredSlides: centeredSlides,
          loop: false
        });
        return;
      }

      // Desktop Swiper config
      var parentSection = container.closest('.featured-products-list');
      var nextEl = parentSection ? parentSection.querySelector('.featured-products-list__nav--next') : null;
      var prevEl = parentSection ? parentSection.querySelector('.featured-products-list__nav--prev') : null;

      new Swiper(container, {
        slidesPerView: Math.min(slidesCount, Math.min(productsToShow, 3)),
        spaceBetween: 0,
        loop: slidesCount > productsToShow,
        centeredSlides: false,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        breakpoints: {
          1100: {
            slidesPerView: Math.min(slidesCount, Math.min(productsToShow, 4)),
            spaceBetween: 0
          },
          1360: {
            slidesPerView: Math.min(slidesCount, Math.min(productsToShow, 5)),
            spaceBetween: 0
          },
          1600: {
            slidesPerView: Math.min(slidesCount, productsToShow),
            spaceBetween: 0
          }
        }
      });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () { initFeaturedProductsSlider(); }, 300);
    });
  } else {
    setTimeout(function () { initFeaturedProductsSlider(); }, 300);
  }

  // Reinitialize on resize (handles desktop <-> mobile transition)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initFeaturedProductsSlider();
    }, 250);
  });

  // Reinitialize on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-featured-products-slider]')) {
      setTimeout(function () { initFeaturedProductsSlider(event.target); }, 100);
    }
  });

  // Reload section when variant changes (Section Rendering API)
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail.variant;
    if (!variant) return;

    var sectionEls = document.querySelectorAll('.section-featured-products-list');
    if (!sectionEls.length) return;

    var url = window.location.pathname;

    sectionEls.forEach(function (sectionEl) {
      var sectionId = sectionEl.id ? sectionEl.id.replace('shopify-section-', '') : null;
      if (!sectionId) return;

      fetch(url + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContent = doc.querySelector('.section-featured-products-list');

          if (newContent) {
            sectionEl.innerHTML = newContent.innerHTML;
            setTimeout(function () { initFeaturedProductsSlider(sectionEl); }, 100);
          } else {
            // Variant has no shop_the_look data — hide section
            sectionEl.innerHTML = '';
          }
        });
    });
  });
})();
